import Link from "next/link";

const items = [
  ["📊", "Dashboard", "/admin/dashboard"],
  ["🏢", "Empresas", "/admin/empresas"],
  ["🚐", "Conductores", "/admin/conductores"],
  ["👥", "Pasajeros", "/admin/pasajeros"],
  ["🎫", "Reservas", "/admin/reservas"],
  ["🛣️", "Rutas", "/admin/rutas"],
  ["🚗", "Vehículos", "/admin/vehiculos"],
  ["💳", "Pagos", "/admin/pagos"],
  ["📈", "Reportes", "/admin/reportes"],
  ["⚙️", "Config", "/admin/configuracion"],
];

export default function AdminSidebar() {
  return (
    <aside style={{
      width:"260px",
      minHeight:"100vh",
      background:"#07111f",
      borderRight:"1px solid #1a2744",
      padding:"24px 18px",
      position:"fixed",
      left:0,
      top:0
    }}>
      <div style={{fontSize:"22px",fontWeight:900,color:"#fff",marginBottom:"30px"}}>
        MiRuta<span style={{color:"#f5a623"}}>USA</span>
      </div>

      <nav style={{display:"flex",flexDirection:"column",gap:"8px"}}>
        {items.map(([icon,label,href]) => (
          <Link key={href} href={href} style={{
            color:"#b8c4e0",
            textDecoration:"none",
            padding:"13px 14px",
            borderRadius:"10px",
            background: label === "Dashboard" ? "#0f1d36" : "transparent",
            display:"flex",
            gap:"12px",
            alignItems:"center",
            fontSize:"15px"
          }}>
            <span>{icon}</span>
            <span>{label}</span>
          </Link>
        ))}
      </nav>
    </aside>
  );
}
